module.exports = __webpack_public_path__ + "img/heart.437ef2e7.svg";